module.exports = __webpack_public_path__ + "static/media/joinSound.710002b9.mp3";